import * as React from 'react';
import styles from './triangle.scss';

export const Triangle = () => (
  <svg className={`${styles.triangle} triangle`} viewBox="0 0 40 20" height="20px" width="40px">
    <polygon className="triangle-border" fill="#98ADD2" points="37.3,16 30.8,10 20,0 9.2,10 2.7,16 	"/>
    <polygon className="triangle-fill" fill="#fff" points="20,1.5 30,10.8 40,20 20,20 0,20 10,10.8 	"/>
  </svg>
);
